var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{key:_vm.deleteButtonKey,staticClass:"ml-3 px-5 btn-drop flex justify-center items-center",attrs:{"variant":"bordered-error","id":"delete-button"},on:{"click":_vm.onClick}},[_c('delete-icon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }